export default __webpack_public_path__ + "static/media/p83.c005f154.jpg";